import { Pipe, PipeTransform } from "@angular/core";
import { Constants } from "../../../models/constants";

@Pipe({
    standalone: true,
    name: "cssClassBasedOnEntityTypeId",
})
export class CssClassBasedOnEntityTypeIdPipe implements PipeTransform {
    transform(value: number): string {
        switch (value) {
            case Constants.EntityTypes.ORG:
                return "org";
            case Constants.EntityTypes.BU:
                return "bu";
            case Constants.EntityTypes.PROJECT:
                return "project";
            case Constants.EntityTypes.TEAM:
                return "team";
            default:
                return "";
        }
    }
}
